<div class="contenedorDetalle">
  <div class="detalleHeader">
    <h2>Detalle Instalación</h2>
    <div class="displayFlex ">
      <div
        *ngIf="
          path !== 'instalaciones' &&
          path !== '/contratista/estado/instalaciones'
        "
      >
        <button (click)="disableInput()">Editar</button>
      </div>

      <!-- <button class="button__secondary">Imprimir</button>
      <button class="button__secondary">Descarga</button> -->
    </div>
  </div>
  <div>
    <form novalidate [formGroup]="detalleInstalacion">
      <div>
        <h3>Datos de Instalacion</h3>
        <div>
          <div class="displayFlex">
            <label for="nombre">Denominación</label>
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="nombre"
              id="nombre"
            />
          </div>
          <div formGroupName="direccion" class="displayFlex domicilioFiscal">
            <label for="direccion">Dirección</label>

            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="via"
              id="via"
            />
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="nombreVia"
              id="nombreVia"
            />

            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="provincia"
              id="provincia"
            />
            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="ccaa"
              id="ccaa"
            />

            <input
              [attr.disabled]="disableInputBox ? true : null"
              type="text"
              formControlName="codigoPostal"
              id="codigoPostal"
            />
          </div>
        </div>
        <div *ngIf="!disableInputBox">
          <button (click)="updateInstalacionById()">Guardar</button>
        </div>
      </div>
    </form>
    <div>
      <h3>Zonas y Agrupaciones</h3>
      <div>Zonas:</div>
      <div
        *ngIf="instalacion?.zonas?.length; else elseBlock"
        class="displayFlex"
      >
        <div *ngFor="let zona of instalacion?.zonas">
          <p class="zonas">{{ zona?.nombre }}</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
      <div>Campos (Grupos):</div>
      <div
        class="displayFlex"
        *ngIf="campos?.length; else elseBlock"
      >
        <div *ngFor="let campo of campos">
          <p class="agrupaciones">{{ campo?.nombre }} ({{ campo?.agrupacion?.nombre }})</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
    </div>
    <a *ngIf="path === '/cliente/instalaciones'" 
    [routerLink]="['cliente/centros']" (click)="setIdInstalacion(instalacion.id)" [mat-dialog-close]>
      Ir a tabla Centros
    </a>
    <a *ngIf="path === '/inproeco/estado/instalaciones'" 
    [routerLink]="['inproeco/estado/centros']" (click)="setIdInstalacion(instalacion.id)" [mat-dialog-close]>
      Ir a tabla Centros
    </a>
    <a *ngIf="path === '/contratista/estado/instalaciones'" 
    [routerLink]="['/contratista/estado/centros']" (click)="setIdInstalacion(instalacion.id)" [mat-dialog-close]>
      Ir a tabla Centros
    </a>
    <div>
      <h3>Contratistas</h3>
      <div
        *ngIf="instalacion?.contratistas?.length; else elseBlock"
        class="displayFlex"
      >
        <div *ngFor="let contratista of instalacion?.contratistas">
          <p class="contratistas">{{ contratista.nombreComercial }}</p>
        </div>
      </div>
      <ng-template #elseBlock>-</ng-template>
    </div>
  </div>
</div>
